import type { SessionTemplate, SessionTemplateCreate, SessionTemplateUpdate } from "../domain/SessionTemplate";
import { SessionTemplatesRepository } from "../infrastructure/api/SessionTemplatesRepository";

export function listSessionTemplates(): Promise<SessionTemplate[]> {
    return new SessionTemplatesRepository().listTemplates();
}

export function createSessionTemplate(data: SessionTemplateCreate): Promise<SessionTemplate> {
    return new SessionTemplatesRepository().createTemplate(data);
}

export function updateSessionTemplate(templateId: string, data: SessionTemplateUpdate): Promise<SessionTemplate> {
    return new SessionTemplatesRepository().updateTemplate(templateId, data);
}

export function deleteSessionTemplate(templateId: string): Promise<void> {
    return new SessionTemplatesRepository().deleteTemplate(templateId);
}
